export function initHelpers() {
  const body = document.body;
  const select = (e) => document.querySelector(e);
  const selectAll = (e) => document.querySelectorAll(e);
  //const container = select('.site-main');
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }
}
// ─── Animated Headings (scroll-triggered SplitText) ───────────────────────
// ─── Shared helper: set off-screen state ──────────────────────────────────
export function setOffScreenState() {
  const isMobile = window.innerWidth <= 540;
  if ($(".once-in-inv").length) {
    gsap.set("main .once-in-inv", {
      y: isMobile ? "-140vh" : "-140vh",
    });
  }
  if ($(".once-in").length) {
    gsap.set("main .once-in", {
      y: isMobile ? "140vh" : "120vh",
    });
  }
  if ($(".once-in-left").length) {
    gsap.set("main .once-in-left", {
      x: "-80vw",
    });
  }
  if ($(".once-in-right").length) {
    gsap.set("main .once-in-right", {
      x: "125vw",
    });
  }

  if ($(".show-up").length) {
    gsap.set("main .show-up", {
      opacity: 0,
    });
  }

  // Ocultar headings inicialmente (evita parpadeos antes del SplitText)
  gsap.set("#animated-heading", { visibility: "hidden" });

  if (
    $(".moon_separator span:first-child, .moon_separator span:last-child")
      .length
  ) {
    gsap.set(
      "main .moon_separator span:first-child,main .moon_separator span:last-child",
      {
        scaleX: "0",
      },
    );
  }
  if ($(".moon_separator .moon_separator_moon").length) {
    gsap.set("main .moon_separator_moon", {
      scale: "0",
      rotate: "100deg",
      opacity: 0,
    });
  }
}

// ─── Animate in (initial load + after page transition) ────────────────────
export function animateIn(delay = 0.65) {
  const tl = gsap.timeline({ delay });

  // 1. PRIMERO: Procesar y animar los Headings
  const headingLines = [];
  document.querySelectorAll("#animated-heading").forEach((heading) => {
    const splitInner = new SplitText(heading, {
      type: "lines",
      linesClass: "line",
    });
    new SplitText(heading, {
      type: "lines",
      linesClass: "lineParent",
    });

    gsap.set(heading.querySelectorAll(".lineParent"), { overflow: "hidden" });
    gsap.set(splitInner.lines, { yPercent: 110 });
    gsap.set(heading, { visibility: "visible" });

    // Guardamos todas las líneas de los headings para meterlas al timeline
    headingLines.push(...splitInner.lines);
  });

  // Agregamos la animación de los headings al inicio absoluto de la timeline (posición 0)
  if (headingLines.length > 0) {
    tl.to(
      headingLines,
      {
        yPercent: 0,
        duration: 0.9,
        stagger: 0.08,
        ease: "expo.out",
      },
      0,
    );
  }

  // Estados iniciales específicos para el Hero
  if ($(".hero-home .moon_separator").length) {
    gsap.set(
      ".hero-home .moon_separator span:first-child, .hero-home .moon_separator span:last-child",
      { scaleX: 0 },
    );
    gsap.set(".hero-home .moon_separator_moon", {
      scale: 0,
      rotate: "100deg",
      opacity: 0,
    });
  }

  // 2. SEGUNDO: Animaciones de 'once-in' (desplazadas en el tiempo para que entren DESPUÉS)
  // Usamos el parámetro de posición (ej. 0.3 o 0.4) para que arranquen cuando los títulos van a mitad de camino o terminando
  if ($(".once-in-inv,.once-in").length) {
    tl.to(
      ["main .once-in-inv", "main .once-in"],
      {
        duration: 0.85,
        y: "0vh",
        opacity: "1",
        stagger: 0.04,
        ease: "expo.out",
      },
      0.3, // <-- Arranca en el segundo 0.3 de la línea de tiempo
    );
  }

  if ($(".once-in-left,.once-in-right").length) {
    tl.to(
      ["main .once-in-left", "main .once-in-right"],
      {
        duration: 0.85,
        x: "0",
        opacity: "1",
        stagger: 0.04,
        ease: "expo.out",
      },
      0.3,
    );
  }

  if ($(".show-up").length) {
    tl.to(
      "main .show-up",
      {
        duration: 1.2,
        opacity: 1,
        stagger: 0.04,
        ease: "expo.out",
      },
      0.3,
    );
  }

  // Animación del separador del HERO al cargar
  if ($(".hero-home .moon_separator span").length) {
    tl.to(
      [
        ".hero-home .moon_separator span:first-child",
        ".hero-home .moon_separator span:last-child",
      ],
      {
        duration: 0.85,
        scaleX: 1,
        stagger: 0.04,
        ease: "expo.out",
      },
      0.5,
    );
  }

  if ($(".hero-home .moon_separator_moon").length) {
    tl.to(
      ".hero-home .moon_separator_moon",
      {
        duration: 0.65,
        scale: 1,
        rotate: "0deg",
        opacity: 1,
        stagger: 0.04,
        ease: "expo.out",
      },
      0.5,
    );
  }

  tl.call(() => ScrollTrigger.refresh());
  return tl;
}
// ─── Initial page load ────────────────────────────────────────────────────
export function initLoader() {
  setOffScreenState();
  document.fonts.ready.then(() => {
    // CAMBIO: 0.9 segundos (900ms) o usa 9 para 9 segundos enteros
    animateIn(2.5);
  });
}
// ─── Leave: quickly hide outgoing page ────────────────────────────────────
export function pageTransitionIn() {
  return gsap.to("main", {
    duration: 0.25,
    opacity: 0,
    ease: "Power2.easeIn",
  });
}
// ─── Enter: reveal incoming page ──────────────────────────────────────────
export function pageTransitionOut() {
  gsap.set("main", {
    opacity: 1,
  }); // reset fade from leave
  setOffScreenState();
  animateIn(0); // no extra delay — fires right away
}
///////////////////////////////////////////////////////
export function initNextWord(data) {
  // update Text Loading https://github.com/barbajs/barba/issues/507
  let parser = new DOMParser();
  let dom = parser.parseFromString(data.next.html, "text/html");
  let nextProjects = dom.querySelector(".loading-words");
  document.querySelector(".loading-words").innerHTML = nextProjects.innerHTML;
}
export function delay(n) {
  n = n || 2000;
  return new Promise((done) => {
    setTimeout(() => {
      done();
    }, n);
  });
}
/**
 * Window Inner Height Check
 */
export function initWindowInnerheight() {
  // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  $(document).ready(function () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    $(".btn-hamburger").click(function () {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  });
}
/**
 * Check touch device
 */
export function initCheckTouchDevice() {
  function isTouchScreendevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }
  if (isTouchScreendevice()) {
    $("main").addClass("touch");
    $("main").removeClass("no-touch");
  } else {
    $("main").removeClass("touch");
    $("main").addClass("no-touch");
  }
  $(window).resize(function () {
    if (isTouchScreendevice()) {
      $("main").addClass("touch");
      $("main").removeClass("no-touch");
    } else {
      $("main").removeClass("touch");
      $("main").addClass("no-touch");
    }
  });
}
/**
 * Cookie Views
 */
export function initCookieViews() {
  // Set cookie for columns/rows view
  // https://www.youtube.com/watch?v=rfwiyBoVwdQ&ab_channel=TimothyRicks
  if (Cookies.get("view") == "columns") {
    //scroll.update();
    ScrollTrigger.refresh();
  }
}
/**
 * Scrolltrigger Nav
 */
export function initTricksWords() {
  // Copyright start
  // © Code by T.RICKS, https://www.tricksdesign.com/
  // You have the license to use this code in your projects but not redistribute it to others
  // Tutorial: https://www.youtube.com/watch?v=xiAqTu4l3-g&ab_channel=TimothyRicks
  // Find all text with .tricks class and break each letter into a span
  var spanWord = document.getElementsByClassName("span-lines");
  for (var i = 0; i < spanWord.length; i++) {
    var wordWrap = spanWord.item(i);
    wordWrap.innerHTML = wordWrap.innerHTML.replace(
      /(^|<\/?[^>]+>|\s+)([^\s<]+)/g,
      '$1<span class="span-line"><span class="span-line-inner">$2</span></span>',
    );
  }
}
/**
 * Lazy Load
 */
export function initLazyLoad() {
  // https://github.com/locomotivemtl/locomotive-scroll/issues/225
  // https://github.com/verlok/vanilla-lazyload
  var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
  });
}
/***
 Play Video Inview
*/
export function playVideoInview() {
  function isInsidePinnedSection(el) {
    return el.closest(".scroll-section");
  }
  function initPlayVideoInview() {
    ScrollTrigger.getAll().forEach((t) => {
      if (t.vars.id === "video-inview") t.kill();
    });
    let allVideoDivs = gsap.utils.toArray(".playpauze");
    allVideoDivs.forEach((videoDiv) => {
      let videoElem = videoDiv.querySelector("video");
      if (!videoElem) return;
      // 🎯 SI está dentro de una sección pinneada → desktop
      if (isInsidePinnedSection(videoElem) && window.innerWidth >= 1024) {
        videoElem.play().catch(() => {});
        return;
      }
      // 📱 Mobile / secciones normales
      ScrollTrigger.create({
        id: "video-inview",
        trigger: videoDiv, // 👈 NO el video
        start: "top 80%",
        end: "bottom 20%",
        //markers: true,
        onEnter: () => videoElem.play(),
        onEnterBack: () => videoElem.play(),
        onLeave: () => videoElem.pause(),
        onLeaveBack: () => videoElem.pause(),
      });
    });
    ScrollTrigger.refresh();
  }
}

// GOOGLE TRADUCTOR
export function initGoogleTranslate() {
  function revealWhenTranslated() {
  const html = document.documentElement;

  // Si no había traducción pendiente, no hay nada que esperar
  if (!html.classList.contains('gt-loading')) return;

  const reveal = () => {
    html.classList.remove('gt-loading');
    observer.disconnect();
    clearTimeout(fallback);
  };

  const observer = new MutationObserver(() => {
    if (
      html.classList.contains('translated-ltr') ||
      html.classList.contains('translated-rtl')
    ) {
      reveal();
    }
  });

  observer.observe(html, { attributes: true, attributeFilter: ['class'] });

  // Fallback: si por lo que sea Google no responde, no dejamos la página
  // invisible para siempre (ej. bloqueado por adblock, caída del servicio)
  const fallback = setTimeout(reveal, 4000);
}

revealWhenTranslated();

  if (window.__gtInitDone) return;
  window.__gtInitDone = true;

  const SOURCE_LANG = "es";

  function getCurrentLang() {
    const match = document.cookie.match(/googtrans=\/[a-z]{2}\/([a-z]{2})/i);
    return match ? match[1] : SOURCE_LANG;
  }

  function setLang(lang) {
    const domain = window.location.hostname;
    const value = lang === SOURCE_LANG ? "" : `/${SOURCE_LANG}/${lang}`;

    if (!value) {
      // Volver al idioma original: hay que borrar la cookie, no vaciarla
      document.cookie = `googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
      document.cookie = `googtrans=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
      document.cookie = `googtrans=; path=/; domain=.${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
    } else {
      document.cookie = `googtrans=${value}; path=/`;
      document.cookie = `googtrans=${value}; path=/; domain=${domain}`;
      document.cookie = `googtrans=${value}; path=/; domain=.${domain}`;
    }
  }

  function syncLangLabel() {
    document.querySelectorAll(".lang-name").forEach((el) => {
      el.textContent = getCurrentLang().toUpperCase();
    });
  }
  syncLangLabel();

  // --- Dropdown open/close (sin cambios) ---
  document.querySelectorAll(".dropdown-toggle").forEach(dropDownFunc);
  function dropDownFunc(dropDown) {
    if (dropDown.classList.contains("click-dropdown")) {
      dropDown.addEventListener("click", function (e) {
        e.preventDefault();
        if (this.nextElementSibling.classList.contains("dropdown-active")) {
          this.parentElement.classList.remove("dropdown-open");
          this.nextElementSibling.classList.remove("dropdown-active");
        } else {
          closeDropdown();
          this.parentElement.classList.add("dropdown-open");
          this.nextElementSibling.classList.add("dropdown-active");
        }
      });
    }
  }
  window.addEventListener("click", function (e) {
    if (e.target.closest(".dropdown-container") === null) closeDropdown();
  });
  function closeDropdown() {
    document.querySelectorAll(".dropdown-container").forEach((c) => c.classList.remove("dropdown-open"));
    document.querySelectorAll(".dropdown-menu").forEach((m) => m.classList.remove("dropdown-active"));
  }
  document.querySelectorAll(".dropdown-menu").forEach((el) => (el.onmouseleave = closeDropdown));

  // --- Click en item de idioma: cookie + reload, sin depender del combo ---
  (function ($) {
    $(document).on("click", ".translate__item", function () {
      const lang = $(this).data("value");
      if (lang === getCurrentLang()) return; // ya está en ese idioma

      setLang(lang);
      location.reload();
    });
  })(jQuery);
}
